import React, { FC } from 'react';
import { IoClose } from 'react-icons/io5';

import TransparentButton from '../button-transparent';

interface CustomDrawerProps {
  children: React.ReactNode;
  title: string;
  open: boolean;
  titleClassName?: string;
  onClose: () => void;
  showCloseButton?: boolean;
}

const CustomDrawer: FC<CustomDrawerProps> = ({
  title,
  showCloseButton = true,
  onClose,
  children,
  open,
  titleClassName,
}) => {
  return (
    <>
      <TransparentButton
        itemType="submit"
        onClick={onClose}
        className={
          !open
            ? 'w-0 p-0 m-0 h-0 hidden'
            : 'z-40 visible bg-black hover:!bg-black opacity-20 w-full h-full fixed start-0 top-20'
        }
      />
      <div
        style={{ transition: window.screen.width < 768 ? 'height 0.5s' : 'width 0.3s' }}
        className={`fixed overflow-y-auto no-scrollbar start-0 top-20 bg-white ${
          !open ? 'w-0 h-0 p-0' : 'md:w-[394px] w-full px-8 py-6'
        } h-full z-50`}
      >
        <div className={open ? 'visible md:delay-200' : 'invisible'}>
          <div className={`flex flex-row justify-between items-center ${titleClassName}`}>
            <span className="text-lg font-bold">{title}</span>
            {showCloseButton && <IoClose className="md:hidden" onClick={onClose} />}
          </div>
          {children}
        </div>
      </div>
    </>
  );
};

export default CustomDrawer;
